
export const fieldsToSearchByTab = {
    ASIGNACION: [
        'idEvaluacion',
        'tipoEvaluacion',
        'programa',
        'codSap',
        'cliente',
        'paciente',
        'hC',
        'estadoValidacion',
        'estadoRI',
        'profesionalASignado'
    ],
    VALIDACION: [
        'idEvaluacion',
        'programa',
        'cliente',
        'paciente',
        'profesionalASignado'
    ],
    INGRESO_INDICACION: [
        'idEvaluacion',
        'programa',
        'cliente',
        'paciente'
    ],
    CAMBIO_INDICACION: [
        'idEvaluacion',
        'programa',
        'cliente',
        'paciente'
    ],
    CONFIRMAR_EQUIPO: [
        'idEvaluacion',
        'programa',
        'cliente',
        'paciente'
    ],
    CAMBIO_PROGRAMA: [
        'idEvaluacion',
        'programa',
        'cliente',
        'paciente'
    ]
};